exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".toolbar{color:red}.md-toolbar.md-default-theme:not(.md-menu-toolbar).md-accent,.md-toolbar.md-default-theme:not(.md-menu-toolbar).md-accent md-icon,md-toolbar:not(.md-menu-toolbar).md-accent,md-toolbar:not(.md-menu-toolbar).md-accent md-icon{color:#fff!important}.sb-shell>toolbar>md-toolbar.fixed{position:fixed}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/layout/toolbar/toolbar.scss
// module id = 459
// module chunks = 0